<template>
  <b-container v-if="idToken" class="default-color">
    <div id="claimKeyDiv">
      <p>Select an available game below and click Claim Key. The key is considered claimed once it is displayed below.
        You should save it for your records if you will not be adding it to your library immediately.</p>
      <p>For more information on adding a game to your Steam Library follow the instructions
        <a href="https://support.steampowered.com/kb_article.php?ref=5414-tfbn-1352" target="_blank">here</a></p>
      <b-row>
        <b-col>
          <b-select v-model="selected" :options="keyOptions"/>
        </b-col>
        <b-col>
          <b-button type="submit" variant="outline-danger" v-bind:disabled="!selected" @click="onSubmit">Claim
          </b-button>
        </b-col>
      </b-row>
      <div class=" mt-3" v-bind:class="{'claimedKey': keySelected, 'text-danger':keyError}" v-html="keyToClaim"/>
    </div>

  </b-container>
  <div v-else>
    Problem loading form
  </div>
</template>

<script>
  import axios from 'axios'

  export default {
    name: 'SteamKeyClaimForm',
    props: {
      idToken: String,
      unclaimedKeys: Array
    },
    data () {
      return {
        keyOptions: [
          { value: null, text: 'Select a game' }
        ],
        keyToClaim: '',
        keySelected: false,
        keyError: false,
        selected: null
      }
    },
    created () {
      let context = this
      if (this.unclaimedKeys.length > 0) {
        this.unclaimedKeys.forEach(function (item) {
          context.keyOptions.push({ value: item.steam_key.S, text: item.name.S })
        })
      }
    },
    methods: {

      onSubmit (e) {
        e.preventDefault()
        let confirmClaim = confirm('Claim the selected key?')
        if (confirmClaim) {
          this.confirmedSubmit(this.selected)
        }
      },
      async confirmedSubmit (key) {
        let postData = {
          steamKey: key
        }

        let claimKeyPostRequest = {
          method: 'POST',
          url: 'https://3deddkpozj.execute-api.us-east-2.amazonaws.com/test/apopkeystore/claim',
          crossDomain: true,
          data: postData,
          headers: {
            'content-type': 'application/json',
            'x-apop-token': this.idToken
          }
        }

        axios(claimKeyPostRequest).then(response => {
          this.keySelected = true
          this.keyToClaim = key
        }).catch(err => {
          this.keyError = true
          this.keyToClaim = 'An unexpected error has occurred claiming this key.  Please refresh and try again.  ' +
            '<br/>If this error persists or you do not see the game available any longer, please contact the administrators.' +
            '<br/>Error message: ' + err.response.data.message
        })
      }
    }
  }
</script>
